// extracted by mini-css-extract-plugin
export default {"card":"card_card__Cqrt5","wordContainer":"card_wordContainer__Wz3Ps","word":"card_word__VqfKF","transcription":"card_transcription__wSvBy","russian":"card_russian__Zp1FN"};